import React from 'react';
import EmptyStateController from 'components/EmptyStateController';
import { useFetchMyCalendarSettings } from './hooks/useFetchMyCalendarSettings';
import CalendarDisconnectedContent from './CalendarDisconnectedContent';
import CalendarLinkedContent from './CalendarLinkedContent';
import CalendarDeAuthorisedContent from './CalendarDeAuthorisedContent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CalendarIntegrationContent() {
  var _data$hasAccountLinke, _data$hasActiveSubscr;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    defaultProvider = _ref.defaultProvider,
    onClose = _ref.onClose;
  var _useFetchMyCalendarSe = useFetchMyCalendarSettings(),
    data = _useFetchMyCalendarSe.data,
    isLoading = _useFetchMyCalendarSe.isLoading,
    isError = _useFetchMyCalendarSe.isError;
  var hasAccountLinked = (_data$hasAccountLinke = data === null || data === void 0 ? void 0 : data.hasAccountLinked) !== null && _data$hasAccountLinke !== void 0 ? _data$hasAccountLinke : false;
  var hasActiveSubscription = (_data$hasActiveSubscr = data === null || data === void 0 ? void 0 : data.hasActiveSubscription) !== null && _data$hasActiveSubscr !== void 0 ? _data$hasActiveSubscr : false;
  return /*#__PURE__*/_jsxs(EmptyStateController, {
    isLoading: isLoading,
    isError: isError,
    isEmpty: !data,
    data: data,
    children: [!hasAccountLinked && /*#__PURE__*/_jsx(CalendarDisconnectedContent, {
      defaultProvider: defaultProvider
    }), hasAccountLinked && hasActiveSubscription && data && /*#__PURE__*/_jsx(CalendarLinkedContent, {
      settings: data,
      onClose: onClose
    }), hasAccountLinked && !hasActiveSubscription && data && /*#__PURE__*/_jsx(CalendarDeAuthorisedContent, {
      settings: data
    })]
  });
}
export default CalendarIntegrationContent;